import { bookingDurationAtom, isBookingMultiDayAtom } from 'components/forms/bookingWidget/jotaiStore';
import { Flex, FlexCol } from 'components/primitives/flex';
import Button from 'components/ui/Button/Button';
import { mediaMMdMax } from 'helpers/breakpoints';
import { dollarsNoCentsWithSymbol } from 'helpers/currency';
import { useTripCalculator } from 'hooks/queries';
import { useAtom, useAtomValue } from 'jotai';
import styled from 'styled-components';
import { ButtonContainer } from './shared';

interface SubmitMessageOwnerProps {
  isSmallScreen: boolean;
  isProcessing: boolean;
  isViewerOwner: boolean;
}
export default ({ isSmallScreen, isProcessing, isViewerOwner }: SubmitMessageOwnerProps) => {
  const { tripCalculation } = useTripCalculator();
  const isBookingMultiDay = useAtomValue(isBookingMultiDayAtom);
  const [bookingDuration] = useAtom(bookingDurationAtom);

  return (
    <ButtonContainer data-testid="pdp-booking-widget-submit-container">
      <Flex gap="40px">
        {isSmallScreen && (
          <PriceWrapper data-testid="price-wrapper-small-screen">
            <Price>{dollarsNoCentsWithSymbol(tripCalculation?.pre_tax_and_fees_booking_total || 0)}</Price>
            <Duration>
              {isBookingMultiDay ? bookingDuration?.label : bookingDuration?.label?.replace('hours', 'hr')} (excl. fees)
            </Duration>
          </PriceWrapper>
        )}
        <Button
          fullWidth
          loading={isProcessing}
          disabled={isViewerOwner || isProcessing}
          text={isViewerOwner ? 'you own this boat' : 'send message'}
          type="submit"
        />
      </Flex>
    </ButtonContainer>
  );
};

const PriceWrapper = styled(FlexCol)`
  align-items: end;
  min-width: 140px;

  ${mediaMMdMax} {
    align-items: flex-start;
  }
`;

const Price = styled.div`
  font-weight: 700;
  font-size: 20px;
`;

const Duration = styled.div`
  color: #8e9697;
  font-weight: 500;
`;
